const IMAGE_FIELD_CANDIDATES = ['url', 'path', 'image', 'filename', 'name', 'src', 'location', 'secure_url'];

const tryParseJSON = (value) => {
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

const listifyImageValue = (value) => {
  if (!value) return [];

  if (Array.isArray(value)) {
    return value.flatMap((item) => listifyImageValue(item));
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return [];

    if (
      (trimmed.startsWith('[') && trimmed.endsWith(']')) ||
      (trimmed.startsWith('{') && trimmed.endsWith('}'))
    ) {
      const parsed = tryParseJSON(trimmed);
      if (parsed !== null) {
        return listifyImageValue(parsed);
      }
    }

    if (trimmed.includes(',')) {
      return trimmed
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean);
    }

    return [trimmed];
  }

  if (typeof value === 'object') {
    for (const key of IMAGE_FIELD_CANDIDATES) {
      if (typeof value[key] === 'string' && value[key].trim()) {
        return listifyImageValue(value[key]);
      }
    }
    return [];
  }

  return [];
};

export const getProductId = (product = {}) =>
  product?.id || product?._id || product?.product_id || product?.productId || '';

export const extractProductImages = (product = {}) => {
  const raw = product?.images ?? product?.image;
  const normalized = listifyImageValue(raw)
    .map((item) => String(item).trim())
    .filter(Boolean);

  return [...new Set(normalized)];
};

export const buildProductImageUrl = (rawImageValue, backendBase = '') => {
  const [firstImage = ''] = listifyImageValue(rawImageValue);
  const img = String(firstImage || '').trim();
  if (!img) return '';

  if (/^https?:\/\//i.test(img) || img.startsWith('data:')) {
    return img;
  }

  const normalized = img.replace(/\\/g, '/').replace(/^\/+/, '');
  const backend = String(backendBase || '').trim().replace(/\/+$/, '');

  const uploadIndex = normalized.indexOf('uploads/');
  if (uploadIndex >= 0) {
    const uploadRelativePath = normalized.slice(uploadIndex);
    return backend ? `${backend}/${uploadRelativePath}` : `/${uploadRelativePath}`;
  }

  if (/^(storage|public)\//i.test(normalized)) {
    return backend ? `${backend}/${normalized}` : `/${normalized}`;
  }

  return backend ? `${backend}/uploads/${normalized}` : `/uploads/${normalized}`;
};
